const BookmarkIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 100 100" width="100" height="100">
        <path d="M20 10 L80 10 L80 90 L50 68 L20 90 Z" fill="currentColor" />
    </svg>
);
export default BookmarkIcon;
